'use strict';
import domReady from '@wordpress/dom-ready';
import QRCodeStyling from 'qr-code-styling'

const logPrefix = '[inline-share]';
const logError = (...args) => console.error(logPrefix, ...args);

domReady(() => {

	let hiding = false;
	let showing = false;

	const hideShareModal = (wrapper) => {
		if (hiding) {
			return;
		}
		hiding = true;
		const content = wrapper.querySelector('.share_qr_modal_content')
		content.style.transform = 'translateY(-20px)';
		content.style.opacity = 0;
		wrapper.style.opacity = 0

		setTimeout(() => {
			wrapper.style.display = 'none'
			hiding = false;
		}, 300)
	}

	const showShareModal = (wrapper) => {
		if (showing) {
			return;
		}
		showing = true;
		
		const content = wrapper.querySelector('.share_qr_modal_content');
		const qrContainer = wrapper.querySelector('.qr_code');
		const canvases = qrContainer ? qrContainer.querySelectorAll('canvas') : [];
		
		content.style.transform = 'translateY(-20px)';
		content.style.opacity = 0;
		wrapper.style.opacity = 0;
		wrapper.style.display = '';
		setTimeout(() => {
			content.style.transform = 'translateY(0)';
			content.style.opacity = 1;
			wrapper.style.opacity = 1;
			showing = false;
			
			const finalCanvases = qrContainer ? qrContainer.querySelectorAll('canvas') : [];
			
		}, 50);
	}

	document.querySelectorAll('.wp-block-custom-inline-social-share-levit-block')
		.forEach((block) => {
			const hideButtonsIfHasShareModal = block?.dataset?.hideButtonsIfSharer === 'true',
				sharer = block?.dataset?.showSharer === 'true',
				hasNavigatorShare = typeof navigator.share === 'function';

			if (hideButtonsIfHasShareModal && hasNavigatorShare){
				const buttonsWrapper = block.querySelector('.links');
				if (buttonsWrapper){
					buttonsWrapper.style.display = 'none';
				}
			}

			if (sharer && hasNavigatorShare){
				const button = block.querySelector('.share.sharer');
				if (button){
					button.style.display = '';
				}
			}
		});

	document.addEventListener('click', async (event) => {
		if (event.target.matches('.wp-block-custom-inline-social-share-levit-block .copy') || event.target.closest('.wp-block-custom-inline-social-share-levit-block .copy')){
			event.preventDefault();

			const copyButton = event.target.matches('.wp-block-custom-inline-social-share-levit-block .copy') ? event.target : event.target.closest('.wp-block-custom-inline-social-share-levit-block .copy');

			const isCopied = inlineSocialShareCopy(copyButton.href);

			if (isCopied){
				copyButton.classList.add('success');
				setTimeout(() => {
					copyButton.classList.remove('success');
				},800)
			} else {
				copyButton.classList.add('error');
				setTimeout(() => {
					copyButton.classList.remove('error');
				},800)
			}
		}

		if (event.target.matches('.wp-block-custom-inline-social-share-levit-block .share.qr') || event.target.closest('.wp-block-custom-inline-social-share-levit-block .share.qr')) {
			event.preventDefault()
			const modalWrapper =  event.target.closest('.wp-block-custom-inline-social-share-levit-block').querySelector('.share_qr_modal')
			const qrContainer = modalWrapper.querySelector('.qr_code');
			const isGenerated = modalWrapper.classList.contains('generated');
			
			if (!isGenerated) {
				const image = modalWrapper.querySelector('img')?.src;
				const mainColor = modalWrapper.dataset.mainColor;
				const secondaryColor = modalWrapper.dataset.secondaryColor;
				let color = '#CB39D8';
				let colorLight = '#CB39D8';

				try {
					color = mainColor || (image ? await __averageColor(image) : '#CB39D8');
					colorLight = secondaryColor || (image ? await __averageColor(image) : '#CB39D8');
				} catch (e) {
					logError('QR color generation failed, using fallback', e);
				}
				
				const qrUrl = event.target.closest('.wp-block-custom-inline-social-share-levit-block .share.qr')?.href;			
				const options = {
					"type": "canvas",
					"shape": "square",
					"width": 232,
					"height": 232,
					"data": qrUrl,
					"margin": 0,
					"imageOptions": {"saveAsBlob": true, "hideBackgroundDots": true, "imageSize": 0.4, "margin": 10},
					"dotsOptions": {"type": "square", "color": color, "roundSize": true},
					"backgroundOptions": {"round": 0, "color": "#ffffff"},
					"image": image,
					"dotsOptionsHelper": {
						"colorType": {"single": true, "gradient": false},
						"gradient": {
							"linear": true,
							"radial": false,
							"color1": "#6a1a4c",
							"color2": "#6a1a4c",
							"rotation": "0"
						}
					},
					"cornersSquareOptions": {"type": "extra-rounded", "color": colorLight},
					"cornersSquareOptionsHelper": {
						"colorType": {"single": true, "gradient": false},
						"gradient": {
							"linear": true,
							"radial": false,
							"color1": "#000000",
							"color2": "#000000",
							"rotation": "0"
						}
					},
					"cornersDotOptions": {"type": "square", "color": colorLight},
					"cornersDotOptionsHelper": {
						"colorType": {"single": true, "gradient": false},
						"gradient": {
							"linear": true,
							"radial": false,
							"color1": "#000000",
							"color2": "#000000",
							"rotation": "0"
						}
					},
					"backgroundOptionsHelper": {
						"colorType": {"single": true, "gradient": false},
						"gradient": {
							"linear": true,
							"radial": false,
							"color1": "#ffffff",
							"color2": "#ffffff",
							"rotation": "0"
						}
					}
				}				
				try {
					const qrCode = new QRCodeStyling(options);					
					if (!qrContainer) {
						logError('qr container not found!');
						return;
					}
					
					qrCode.append(qrContainer);
					
					setTimeout(() => {
						const canvases = qrContainer.querySelectorAll('canvas');
						
						document.body.dispatchEvent(new CustomEvent('levit-inline-social-share-qr-generated', {detail: {modalWrapper}}));
					}, 100);
					
					modalWrapper.classList.add('generated');
				} catch (e) {
					logError('QR code creation/append failed', e);
					return;
				}
			}
			
			showShareModal(modalWrapper);
		}

		if (event.target.matches('.wp-block-custom-inline-social-share-levit-block .share_qr_modal .secondary_button') || event.target.closest('.wp-block-custom-inline-social-share-levit-block .share_qr_modal .secondary_button')) {
			event.preventDefault();

			const modalWrapper = event.target.closest('.share_qr_modal')

			hideShareModal(modalWrapper);
		}
		if (event.target.matches('.wp-block-custom-inline-social-share-levit-block .share_qr_modal .primary_button') || event.target.closest('.wp-block-custom-inline-social-share-levit-block .share_qr_modal .primary_button')) {
			event.preventDefault();

			const modalWrapper = event.target.closest('.share_qr_modal')

			const canvas = modalWrapper.querySelector('canvas')
			let src = '';
			try {
				src = canvas.toDataURL("image/png");
			} catch (e) {
				logError('QR download failed', e);
				return;
			}
			const link = document.createElement("a");
			link.href = src;
			link.download = 'download.png';
			document.body.appendChild(link);

			link.click();

			document.body.removeChild(link);

		}

		if (event.target.matches('.wp-block-custom-inline-social-share-levit-block .share.sharer') || event.target.closest('.wp-block-custom-inline-social-share-levit-block .share.sharer')) {
			event.preventDefault();

			const button = event.target.matches('.wp-block-custom-inline-social-share-levit-block .share.sharer') ? event.target : event.target.closest('.wp-block-custom-inline-social-share-levit-block .share.sharer');

			if (typeof navigator.share !== 'function') {
				button.style.display = 'none';
				return;
			}

			document.body.classList.add('ajax-loading')

			let title = document.title;
			let text = wp.i18n.__('Let\'s support this campaign', 'social-share-levit-block');
			const url = button?.href || '#';

			if (document.querySelector('.levcharity_campaign_heading .levcharity_heading')) {
				title = document.querySelector('.levcharity_campaign_heading .levcharity_heading')?.textContent?.trim();
				text = document.querySelector('.campaign_content_wrapper .levcharity_campaign_content_wrapper .levcharity_paragraph')?.textContent?.trim();
			}

			const message = `${title}\n${text}\n${url}`;

			await navigator.share({
				title: title,
				text: message,
			})
				.then(() => {
					button.classList.add('success')
				})
				.catch(err => {
					button.classList.add('error')
					logError('navigator.share error', err);
				})
				.finally(() => {
					document.body.classList.remove('ajax-loading');
					setTimeout(() => {
						button.classList.remove('error');
						button.classList.remove('success');
					},800)
				})
		}
	});
});

async function inlineSocialShareCopy(text){
    let success = false;

    const selection = window.getSelection();
    let savedSelection = null;
    if (selection.rangeCount > 0) {
        savedSelection = selection.getRangeAt(0);
    }

    if (text instanceof Element) {
        text = text.textContent;
    }

    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(text);
            success = true;
        } catch (e) {
			logError('clipboard API copy failed', e);
		}

    } else {

        const tempElement = document.createElement('textarea');
        tempElement.value = text;
        document.body.appendChild(tempElement);
        tempElement.select();
        try {
            document.execCommand('copy');
            success = true;
        } catch (e) {
			logError('execCommand copy failed', e);
		}

        document.body.removeChild(tempElement);
    }

    if (savedSelection) {
        selection.removeAllRanges();
        selection.addRange(savedSelection);
    }

    return success;
}
async function __averageColor(src, lightness = 0) {
	const img = new Image();
	img.crossOrigin = 'anonymous';
	img.src = src;
	await new Promise((resolve, reject) => {
		img.onload = resolve;
		img.onerror = () => reject(new Error('Image load failed'));
	}).catch((err) => {
		logError('averageColor image load failed', err);
		throw new Error('averageColor image load failed');
	});

	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext("2d");

	canvas.width = img.width;
	canvas.height = img.height;

	ctx.drawImage(img, 0, 0, img.width, img.height);

	const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
	let r = 0, g = 0, b = 0, count = 0;

	for (let i = 0; i < imageData.length; i += 4) {
		r += imageData[i];     // Red
		g += imageData[i + 1]; // Green
		b += imageData[i + 2]; // Blue
		count++;
	}

	r = Math.floor(r / count) + lightness;
	g = Math.floor(g / count) + lightness;
	b = Math.floor(b / count) + lightness;

	if(r > 170 && g > 170 && b > 170){
		r = 170;
	}

	canvas.remove();

	const color = `rgb(${r}, ${g}, ${b})`;
	return color;

}
